$(function() {

  // Force user to select a variant before purchase
  var variant_options = document.querySelectorAll('input.variant_option');
  if (variant_options.length > 0) {
    window.variant_selected_by_user = false;

    var default_option = document.querySelector('input.variant_option:checked');
    default_option.checked = false;

    for (var i = 0; i < variant_options.length; i++) {
      variant_options[i].addEventListener("click", function(e){
        window.variant_selected_by_user = true;

        var option_box = document.querySelector('.variant-options-box');
        option_box.classList.remove('error');
      });
    }

    var buttons = document.querySelectorAll('.call-to-action-buttons, .mobile-element .bottom-bar-wrapper, div.product-personalizer');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", function(event){
        if (window.variant_selected_by_user) { return };

        var target_elements = document.querySelectorAll(
          '.call-to-action-buttons .add-to-cart-main-button,' +
          '.call-to-action-buttons .shopify-payment-button button,' +
          '.bottom-bar-wrapper .buy-now-button,' +
          '.bottom-bar-wrapper .add-to-cart,' +
          'div.product-personalizer button.pplr-c-button'
        );
        var target_element_clicked = false;

        for (var j = 0; j < target_elements.length; j++) {
          if (event.target == target_elements[j]) {
            target_element_clicked = true;
            break;
          }
        }

        if (!target_element_clicked) { return };

        event.stopPropagation();
        event.preventDefault();

        var option_box = document.querySelector('.variant-options-box');
        option_box.classList.add('error');

        var elementRect = option_box.getBoundingClientRect();
        var absoluteElementTop = elementRect.top + window.pageYOffset;
        var middle = absoluteElementTop - (window.innerHeight / 2);
        window.scrollTo(0, middle);

        return false;
      }, true);
    }

  }

});
